export const PASS_OVERCALL = 'landy-advance/PASS';
export const TWO_DIAMOND_NO_PREFERENCE = 'landy-advance/TWO_DIAMOND_NO_PREFERENCE';
export const WEAK_FIT = 'landy-advance/WEAK_FIT';
export const GOOD_FIT = 'landy-advance/GOOD_FIT';
export const STRONG_FIT = 'landy-advance/STRONG_FIT';
export const STRONG_HAND_NO_FIT = 'landy-advance/STRONG_HAND_NO_FIT';
